import 'rc-slider/assets/index.css'
import 'rc-tooltip/assets/bootstrap.css'

import React from 'react'
import { inject,observer } from 'mobx-react'

import Stepper, { Step, StepLabel, StepContent, StepButton } from 'material-ui/Stepper'
import Slide from 'material-ui/transitions/Slide'
import Dialog from 'material-ui/Dialog'
import T from 'i18n-react'
import Input, { InputLabel } from 'material-ui/Input'
import TextField from 'material-ui/TextField'
import { MenuItem } from 'material-ui/Menu'
import { FormControl, FormHelperText } from 'material-ui/Form'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import IconButton from 'material-ui/IconButton'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import { Link } from 'react-router-dom'
import Grid from 'material-ui/Grid'
import Select from 'material-ui/Select'
import Lehrplan, { CompetenceStepPopover } from './lehrplan'
import Avatar from 'material-ui/Avatar'
import Divider from 'material-ui/Divider'
import { indigo } from 'material-ui/colors'
import Chip from 'material-ui/Chip'
import Popover from 'material-ui/Popover'
import { findDOMNode } from 'react-dom'
import Dropzone from 'react-dropzone'
import ButtonBase from 'material-ui/ButtonBase'
import Slider from 'rc-slider'



@inject('newexampleformstore','ui') @observer
class NewExampleForm extends React.Component {
  render () {
    const ui = this.props.ui.newExampleForm
    const {
      classes,
      label,
      asSuggestion,
      asUpdate,
      asAcceptDecline,
      asDeleteRestore,
      lehrplan,
      sendSuggestion,
      sendAccept,
      sendDecline,
      sendUpdate,
      sendPermDelete,
      sendRestore
    } = this.props

    return (
      <Dialog
       fullScreen
       open={ui.open}
      >
       <NewExampleFormHeader
        classes={classes}
        label={label}
        lehrplan={lehrplan}
        asSuggestion={asSuggestion}
        asUpdate={asUpdate}
        asAcceptDecline={asAcceptDecline}
        asDeleteRestore={asDeleteRestore}
        sendSuggestion={sendSuggestion}
        sendAccept={sendAccept}
        sendDecline={sendDecline}
        sendUpdate={sendUpdate}
        sendPermDelete={sendPermDelete}
        sendRestore={sendRestore}
       />
     </Dialog>
    )
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.example) {
      this.props.newexampleformstore.injectExample(nextProps.example)
    }
  }

}

@inject('newexampleformstore','ui','messenger') @observer
class NewExampleFormHeader extends React.Component {
  constructor (props) {
    super(props)

    this.sendSuggestion = this.sendSuggestion.bind(this)
    this.sendAccept = this.sendAccept.bind(this)
    this.sendDecline = this.sendDecline.bind(this)
    this.sendUpdate = this.sendUpdate.bind(this)
    this.sendPermDelete = this.sendPermDelete.bind(this)
    this.sendRestore = this.sendRestore.bind(this)
  }

  render () {
    const {
      classes,
      label,
      asSuggestion,
      asUpdate,
      asAcceptDecline,
      asDeleteRestore,
      lehrplan
     } = this.props,
    ui = this.props.ui.newExampleForm

    let actions = null
    if (asSuggestion) {
      actions = <Button dense color="inherit" onClick={this.sendSuggestion} key={"suggest-example"}>
       {T.translate("newexampleform.sendSuggestion")}
      </Button>
    }
    if (asAcceptDecline) {
      actions = [
       <Button dense color="inherit" onClick={this.sendDecline} key={"decline-example"}>
        <Icon>thumb_down</Icon>
        <span style={{paddingLeft:5}}>{T.translate("newexampleform.decline")}</span>
       </Button>,
       <Button dense color="inherit" onClick={this.sendAccept} key={"accept-example"}>
        <Icon>thumb_up</Icon>
        <span style={{paddingLeft:5}}>{T.translate("newexampleform.accept")}</span>
       </Button>
      ]
    }
    if (asUpdate) {
      actions = <Button color="inherit" onClick={this.sendUpdate}>
       {T.translate("newexampleform.update")}
      </Button>
    }
    if (asDeleteRestore) {
      actions = [
       <Button dense color="inherit" onClick={this.sendPermDelete} key={"perm-delete-example"}>
        <Icon>thumb_down</Icon>
        <span style={{paddingLeft:5}}>{T.translate("newexampleform.permDelete")}</span>
       </Button>,
       <Button dense color="inherit" onClick={this.sendRestore} key={"restore-example"}>
        <Icon>thumb_up</Icon>
        <span style={{paddingLeft:5}}>{T.translate("newexampleform.restore")}</span>
       </Button>
      ]
    }

    return (
      <div className={classes.root}>
        <AppBar className={classes.appBar}>
         <Toolbar>
          <IconButton
           color="inherit"
           onClick={ui.handleClose}
           aria-label="Close"
          > <Icon>close</Icon> </IconButton>
          <div className={classes.flex} />
          {actions}
         </Toolbar>
        </AppBar>
        <NewExampleFormContent
         classes={classes}
         label={label}
         lehrplan={lehrplan}
         asSuggestion={asSuggestion}
         asAcceptDecline={asAcceptDecline}
        />
      </div>
    )
  }

  sendSuggestion () {
    const validatePayload = true
    const payload = this.props.newexampleformstore.getPayload(validatePayload)

    if (payload) {
     this.props.sendSuggestion(payload, (res) => {
      if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_SUCCESS)
      }
      this.props.ui.newExampleForm.handleClose()
     })
    } else {
     this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_PAYLOAD_INCOMPLETE)
   }
  }

  sendAccept () {
    const validatePayload = true
    const payload = this.props.newexampleformstore.getPayload(validatePayload)

    if (payload) {
      this.props.sendAccept(payload, (res) => {
        if (res.success) {
          this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_ACCEPTED)
        }
        this.props.ui.newExampleForm.handleClose()
      })
     } else {
      this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_PAYLOAD_INCOMPLETE)
    }

  }

  sendDecline () {
    const payload = this.props.newexampleformstore.getPayload()
    this.props.sendDecline(payload.id, (res) => {
      if (res.success) {
        this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_DECLINED)
      }
      this.props.ui.newExampleForm.handleClose()
    })
  }

  sendUpdate () {
    const validatePayload = true
    const payload = this.props.newexampleformstore.getPayload(validatePayload)

    if (payload) {
      this.props.sendUpdate(payload, (res) => {
        if (res.success) {
          this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
        }
        this.props.ui.newExampleForm.handleClose()
      })
     } else {
      this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_PAYLOAD_INCOMPLETE)
    }
  }

  sendPermDelete () {
    const payload = this.props.newexampleformstore.getPayload()
    this.props.sendPermDelete(payload.id, (res) => {
      if (res.success) {
        this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_PERM_DELETED)
      }
      this.props.ui.newExampleForm.handleClose()
    })
  }

  sendRestore () {
    const validatePayload = true
    const payload = this.props.newexampleformstore.getPayload(validatePayload)

    if (payload) {
      this.props.sendRestore(payload.id, (res) => {
        if (res.success) {
          this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_RESTORED)
        }
        this.props.ui.newExampleForm.handleClose()
      })
    } else {
      this.props.messenger.handleOpen(this.props.messenger.messages.SUGGESTION_PAYLOAD_INCOMPLETE)
    }
  }

}


@inject('store','newexampleformstore','ui') @observer
class NewExampleFormContent extends React.Component {
  constructor (props) {
    super(props)

    this.store = this.props.newexampleformstore
    this.ui = this.props.ui.newExampleForm
    this.lehrplan = this.props.lehrplan

    this.setType = this.setType.bind(this)
    this.setTitle = this.setTitle.bind(this)
    this.setDescription = this.setDescription.bind(this)
    this.setLink = this.setLink.bind(this)
    this.setLessons = this.setLessons.bind(this)
    this.setContact = this.setContact.bind(this)
    this.makeScreenshot = this.makeScreenshot.bind(this)
  }

  render () {

    const { classes,label,lehrplan,asSuggestion,asAcceptDecline } = this.props
    const ui = this.ui, store = this.store, chipData = store.getChipData(lehrplan),
          beispieltypen = this.props.store.beispieltypen,
          steps = [
           T.translate("newexampleform.stepTitle"),
           T.translate("newexampleform.stepType"),
           T.translate("newexampleform.stepLink"),
           T.translate("newexampleform.stepDesc"),
           "(" + T.translate("meta.optional") + ") " + T.translate("newexampleform.stepCompetencesteps"),
           "(" + T.translate("meta.optional") + ") " + T.translate("newexampleform.stepLessons"),
           "(" + T.translate("meta.optional") + ") " + T.translate("newexampleform.stepImage")
          ]

    if (asSuggestion || asAcceptDecline) {
      steps.push("(" + T.translate("meta.optional") + ") " + T.translate("newexampleform.stepContact"))
    }
    let maxLessons = []
    for (let i = 0; i < store.maxLessons; i++) maxLessons.push(i+1)

    const marks = {
     135:'3 ' + T.translate('meta.lessons'),
     450:'10 ' + T.translate('meta.lessons')
    }

    return (
     <div className={classes.content}>
      <Grid container direction="row" justify="center" alignItems="flex-start" spacing={Number(8)}>
      <Grid item xs={12} className="center-text">
       <Typography type="title"> {label} </Typography>
      </Grid>
       <Grid item xs={12} sm={8} md={6}>

        <Stepper activeStep={ui.step} orientation="vertical" nonLinear>
         {
          steps.map( (stepTitle,index) => (
           <Step key={"step-"+index}>
            <StepButton onClick={this.setStep.bind(this,index)}> {stepTitle} </StepButton>
            <StepContent>

             {ui.step === 0 &&
              <TextField
               id="title"
               placeholder={T.translate("newexampleform.stepTitle") + ".."}
               defaultValue={store.title}
               onChange={this.setTitle}
               fullWidth
              />
             }

             {ui.step === 1 &&
              <FormControl className={classes.formControl}>
               <InputLabel htmlFor="name-simple"> {T.translate("newexampleform.stepType")} </InputLabel>
               <Select
                value={store.type.id}
                onChange={this.setType}
                input={<Input name="name" id="name-simple"/>}
               >
                {beispieltypen.map( (type,index) => {
                  if (index !== 0) {
                   return <MenuItem value={type.id} key={'type-'+type.id}>
                    {type.name}
                   </MenuItem>
                  }
                })}
               </Select>
              </FormControl>
             }

             {ui.step === 2 &&
              <TextField
               id="link"
               placeholder={T.translate("newexampleform.stepLink") + ".."}
               defaultValue={store.link}
               onChange={this.setLink}
               onBlur={this.makeScreenshot}
               fullWidth
              />
             }

             {ui.step === 3 &&
               <TextField
                id="description"
                placeholder={T.translate("newexampleform.stepDesc")}
                multiline
                rows="2"
                rowsMax="4"
                value={store.description}
                onChange={this.setDescription}
                fullWidth
              />
             }

             {ui.step === 4 &&
              <div>
               <Typography component="p" type="caption"> {T.translate("newexampleform.cycles")} </Typography>

               {chipData && chipData.length > 0 &&
                 <div className="chip-container">
                 {chipData.map( ks => {
                   return (
                     <Chip
                      className="lehrplan-chip"
                      avatar={
                        <Avatar
                         className={this.props.ui.getZyklusColor(ks)}> {this.props.ui.getZyklusAsString(ks)} </Avatar>}
                      key={ks.code}
                      label={ks.code}
                      onClick={this.openPopover.bind(this,ks)}
                      onDelete={store.toggleCompetenceStep.bind(this,ks.id)}
                      ref={ chip => {this.chip = chip} }
                     />
                   )
                  })}
                  <CompetenceStepPopover />
                 </div>
               }
               <div>
                <IconButton color="primary" onClick={this.props.ui.lehrplan.handleOpen}>
                 <Icon>add</Icon>
                </IconButton>
                <Lehrplan
                 lehrplan={lehrplan}
                 onSelection={store.setCompetenceSteps}
                 preSelection={store.competenceSteps}
                 label={T.translate("lehrplan.suggestion")}
                />
               </div>
              </div>
             }

             {ui.step === 5 &&
              <div>
               <Typography display="caption"> {T.translate("newexampleform.fromTo")} {T.translate("newexampleform.whatIsALesson")} </Typography>

               <div className={classes.sliderTotals}>
                <Typography type="caption">
                {store.lessonsFromInLessons > 0 &&
                  <Input
                   value={store.lessonsFromInLessons}
                   className={classes.sliderInput}
                   inputProps={{className:classes.sliderInputText}}
                   id="from-lessons-input"
                  />
                }
                {store.lessonsFromInLessons > 1 ? T.translate('meta.lessons') : ''}
                {store.lessonsFromInLessons === 1 ? T.translate('meta.lesson') : ''}
                {store.minutesFromAsRest > 0 &&
                 <Input
                  value={store.minutesFromAsRest}
                  className={classes.sliderInput}
                  inputProps={{className:classes.sliderInputText}}
                  id="from-lessons-minutes-input"
                 />
                }
                {store.minutesFromAsRest > 0 && T.translate('meta.minutes')}

                {store.lessonsToInLessons > 0 && store.hasAToTime && <Typography type="body1" component="p" style={{padding:20}}> {T.translate('meta.to')} </Typography>}
                {store.lessonsToInLessons > 0 && store.hasAToTime &&
                  <Input
                   value={store.lessonsToInLessons}
                   className={classes.sliderInput}
                   inputProps={{className:classes.sliderInputText}}
                   id="to-lessons-input"
                  />
                }
                {store.lessonsToInLessons > 1 && store.hasAToTime ? T.translate('meta.lessons') : ''}
                {store.lessonsToInLessons === 1 && store.hasAToTime ? T.translate('meta.lesson') : ''}
                {store.minutesToAsRest > 0 && store.hasAToTime &&
                 <Input
                  value={store.minutesToAsRest}
                  className={classes.sliderInput}
                  inputProps={{className:classes.sliderInputText}}
                  id="to-lessons-minutes-input"
                 />
                }
                {store.minutesToAsRest > 0 && store.hasAToTime && T.translate('meta.minutes')}
                </Typography>
               </div>

               <Slider
                min={0}
                max={store.maxLessons}
                value={store.lessonsFrom}
                onChange={store.setLessonsFrom}
                marks={marks}
                step={store.MINUTE_STEPS}
                className={classes.slider}
               />

               <Slider
                min={0}
                max={store.maxLessons}
                value={store.lessonsTo}
                onChange={store.setLessonsTo}
                step={store.MINUTE_STEPS}
                marks={marks}
                className={classes.slider}
               />

              </div>
             }

             {ui.step === 6 && <ImageUpload classes={classes} />}

             {ui.step === 7 && (asSuggestion || asAcceptDecline) &&
               <div>
                 <Typography component="p" type="caption"> {T.translate("newexampleform.contact")} </Typography>
                 <TextField
                  id="contact"
                  placeholder={T.translate("newexampleform.stepContact")}
                  value={store.contact}
                  onChange={this.setContact}
                  fullWidth
                 />
               </div>
             }

             {ui.step !== 0 &&
              <Button color="primary" onClick={ui.prevStep}>
               {T.translate("newexampleform.prev")}
              </Button>
             }

             {ui.step < steps.length - 1 &&
               <Button color="primary" onClick={ui.nextStep}>
                {T.translate("newexampleform.next")}
               </Button>
             }

            </StepContent>
           </Step>
          ))
         }

        </Stepper>

       </Grid>
      </Grid>
     </div>
    )
  }

  setTitle (e) {
    this.store.setTitle(e.target.value)
  }

  setStep (step) {
    this.ui.setStep(step)
  }

  setType (e) {
    const type = this.props.store.getBeispielTypById(e.target.value)
    this.store.setType(type)
  }

  setDescription (e) {
    this.store.setDescription(e.target.value)
  }

  setContact (e) {
    this.store.setContact(e.target.value)
  }

  setLink (e) {
    this.store.setLink(e.target.value)
  }

  makeScreenshot (e) {
    this.props.store.makeScreenshot(e.target.value, (res) => {
     this.store.addPreviewImage(res.url)
    })
  }

  setLessons (e) {
   let lessons = e.target.value
   if (e.target.value.length >= 2) {
     lessons = [e.target.value[0],e.target.value[e.target.value.length - 1]]
     e.target.value = lessons
   }
   this.store.setLessons(lessons)
  }

  openPopover (ks) {
    const ui = this.props.ui.lehrplan, anchorEl = findDOMNode(this.chip)

    ui.setPopoverAnchorEl(anchorEl)
    ui.handleOpenStepPopover(ks)
  }

}


@inject('newexampleformstore') @observer
class ImageUpload extends React.Component {
  render () {
   const { classes } = this.props, store = this.props.newexampleformstore
   let previewImages = null
   if (store.previewImages.length > 1) {
     previewImages =
     <Grid container direction="row" className={classes.thumbnailContainer}>
      {store.previewImages.map( (image,index) => (
        <Grid item xs={2} key={"thumbnail-"+index}>
         <ButtonBase
          focusRipple
          style={{backgroundImage:"url("+image+")"}}
          className={classNames(classes.thumbnail,classes.previewFancy,classes.background)}
          onClick={this.setImage.bind(this,image)}
         />
        </Grid>
      ))}
     </Grid>
   }
    return (
      <div>

       <div className={classes.previewContainer}>
        <div style={{backgroundImage:"url("+store.image+")"}} className={classNames(classes.previewImage,classes.previewFancy,classes.background)} />
        {previewImages}
       </div>

       <TextField
        id="imageupload"
        placeholder={T.translate("newexampleform.linkToImage") + ".."}
        fullWidth
        onChange={this.setImageFromURL}
       />
      </div>
    )
  }

  onDrop = (acceptedFiles,rejectedFiles) => {
    const reader = new FileReader()
    reader.onload = () => {
      this.props.newexampleformstore.addPreviewImage(reader.result)
    }
    acceptedFiles.map( file => {
     reader.readAsDataURL(file)
     window.URL.revokeObjectURL(file.preview);
    })
  }

  setImage (url) {
    this.props.newexampleformstore.setImage(url)
  }

  setImageFromURL = (e) => {
    const store = this.props.newexampleformstore
    if (store.isValidURL(e.target.value)) {
     this.props.newexampleformstore.addPreviewImage(e.target.value)
     e.target.value = ""
    }
  }

}


const styles = theme => ({
  root: {
   width: '100%',
   height:'100vh',
   zIndex: 1,
   overflow: 'hidden',
  },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  content: {
   width: '100%',
   overflow:'auto',
   flexGrow: 1,
   paddingLeft:10,
   paddingRight:10,
   backgroundColor: theme.palette.background.default,
   transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
   }),
   height: 'calc(100% - 56px - 48px)',
   marginTop: 56 + 48,
   [theme.breakpoints.up('sm')]: {
     height: 'calc(100% - 64px - 48px)',
    marginTop: 64 + 48,
   },
  },
  formControl: {
   margin: theme.spacing.unit,
   width: "100%",
  },
  dropzone:{
    position:"absolute",
    width:"100%",
    height:"100%"
  },
  previewContainer:{
    position:"relative",
  },
  previewImage:{
    width:"100%",
    minHeight:200,
  },
  previewFancy:{
    transition: "opacity 480ms cubic-bezier(0.165, 0.84, 0.44, 1), transform 480ms cubic-bezier(0.165, 0.84, 0.44, 1)",
    boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)"
  },
  uploadImageButton:{
    position:"absolute",
    top:7,
    right:7
  },
  background:{
    width:"100%",
    backgroundRepeat:"no-repeat",
    backgroundSize:"cover",
    backgroundPosition:"top center",
    cursor:"pointer"
  },
  thumbnailContainer:{
    marginTop:10,
    marginBottom:10
  },
  thumbnail:{
    minHeight:45
  },
  flex: {
    flex: 1,
  },
  slider: {
    width:"90%",
    marginLeft:10,
    marginBottom:30
  },
  sliderTotals:{
    textAlign:'center',
    marginTop:30,
    marginBottom:30,
    minHeight:125
  },
  sliderInput:{
    width:25,
    marginLeft:5,
    marginRight:5
  },
  sliderInputText:{
    textAlign:'center'
  }
})


export default withStyles(styles, { withTheme: true })(NewExampleForm)



// WEBPACK FOOTER //
// ./src/components/newexampleform.js